/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseSource
 */
export interface CaseSource {
    /**
     * 
     * @type {string}
     * @memberof CaseSource
     */
    id?: string;
    /**
     * 
     * @type {any}
     * @memberof CaseSource
     */
    securityCase?: any | null;
    /**
     * 
     * @type {string}
     * @memberof CaseSource
     */
    sourceTechnology?: CaseSourceSourceTechnologyEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseSource
     */
    sourceTechnologyCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseSource
     */
    externalSourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseSource
     */
    sourceName?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseSource
     */
    correlationId?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CaseSource
     */
    sourceMetadata?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof CaseSource
     */
    lastSyncTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof CaseSource
     */
    tenantId?: string;
    /**
     * 
     * @type {Date}
     * @memberof CaseSource
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CaseSource
     */
    updated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CaseSource
     */
    primarySource?: boolean;
}


/**
 * @export
 */
export const CaseSourceSourceTechnologyEnum = {
    MsftXdr: 'MSFT_XDR',
    PaloAltoXdr: 'PALO_ALTO_XDR',
    PaloAltoXsoar: 'PALO_ALTO_XSOAR',
    MsftSentinel: 'MSFT_SENTINEL',
    SumoLogic: 'SUMO_LOGIC',
    Crowdstrike: 'CROWDSTRIKE',
    Sentinelone: 'SENTINELONE',
    Splunk: 'SPLUNK',
    Qradar: 'QRADAR',
    Nessus: 'NESSUS',
    Qualys: 'QUALYS',
    Rapid7: 'RAPID7',
    RsaArcher: 'RSA_ARCHER',
    Servicenow: 'SERVICENOW',
    EtlPipeline: 'ETL_PIPELINE',
    WebApp: 'WEB_APP',
    Email: 'EMAIL',
    Unknown: 'UNKNOWN'
} as const;
export type CaseSourceSourceTechnologyEnum = typeof CaseSourceSourceTechnologyEnum[keyof typeof CaseSourceSourceTechnologyEnum];


/**
 * Check if a given object implements the CaseSource interface.
 */
export function instanceOfCaseSource(value: object): value is CaseSource {
    return true;
}

export function CaseSourceFromJSON(json: any): CaseSource {
    return CaseSourceFromJSONTyped(json, false);
}

export function CaseSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseSource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'securityCase': json['securityCase'] == null ? undefined : json['securityCase'],
        'sourceTechnology': json['sourceTechnology'] == null ? undefined : json['sourceTechnology'],
        'sourceTechnologyCode': json['sourceTechnologyCode'] == null ? undefined : json['sourceTechnologyCode'],
        'externalSourceId': json['externalSourceId'] == null ? undefined : json['externalSourceId'],
        'sourceName': json['sourceName'] == null ? undefined : json['sourceName'],
        'correlationId': json['correlationId'] == null ? undefined : json['correlationId'],
        'sourceMetadata': json['sourceMetadata'] == null ? undefined : json['sourceMetadata'],
        'lastSyncTime': json['lastSyncTime'] == null ? undefined : (new Date(json['lastSyncTime'])),
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'primarySource': json['primarySource'] == null ? undefined : json['primarySource'],
    };
}

export function CaseSourceToJSON(json: any): CaseSource {
    return CaseSourceToJSONTyped(json, false);
}

export function CaseSourceToJSONTyped(value?: CaseSource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'securityCase': value['securityCase'],
        'sourceTechnology': value['sourceTechnology'],
        'sourceTechnologyCode': value['sourceTechnologyCode'],
        'externalSourceId': value['externalSourceId'],
        'sourceName': value['sourceName'],
        'correlationId': value['correlationId'],
        'sourceMetadata': value['sourceMetadata'],
        'lastSyncTime': value['lastSyncTime'] == null ? undefined : ((value['lastSyncTime']).toISOString()),
        'tenantId': value['tenantId'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'primarySource': value['primarySource'],
    };
}

